<template>
  <v-row justify="center" align="center" class="skewed-bg">
    <v-col cols="12" sm="11" md="10" lg="10" style="z-index:1">
      <v-card>
        <v-row justify="center" align="center">
          <v-col cols="11" style="margin-bottom:5%;margin-top:5%">
            <v-container>
              <v-card>
                <v-container>
                  <v-row justify="center" align="center">
                    <v-col cols="11" sm="10" md="6" class="pt-0">
                      <v-col cols="12" align="center" class>
                        <span class="text_title_1">รีเซ็ตรหัสผ่าน</span>
                      </v-col>
                      <!-- <pre>{{param}}</pre>
                      <pre>NOW : {{now}}</pre>
                      <pre>EXPIRE : {{time_expire}}</pre>-->
                      <v-col cols="12" align="center">
                        <v-card>
                          <v-card-title
                            primary-title
                            style=" background-image: linear-gradient(to bottom, #3ea6fa, #2769d7, #0c57d2);"
                          >
                            <font color="white" class="text_title_3 ml-4">บัญชีผู้ใช้</font>
                          </v-card-title>
                          <v-card-text>
                            <v-row justify="center" align="center">
                              <v-col cols="12">
                                <v-list class="ml-2">
                                  <v-list-item>
                                    <v-list-item-icon>
                                      <v-icon>mdi-account-circle-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="text_title_1 text-left"
                                      >คุณ {{ fullname }}</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-icon>
                                      <v-icon>mdi-email</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title class="text_title_1 text-left">{{ email }}</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-divider class="my-5"></v-divider>
                      <v-form ref="form" @submit.prevent="submit">
                        <v-row justify="center" align="center">
                          <v-col cols="12">
                            <span class="text_body_6">รหัสผ่านใหม่</span>
                            <v-text-field
                              v-model="password"
                              outlined
                              dense
                              single-line
                              placeholder="ความยาวอย่างน้อย 8 อักขระ"
                              type="password"
                              :rules="rule_password"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="12">
                            <span class="text_body_6">ยืนยันรหัสผ่าน</span>
                            <v-text-field
                              v-model="confirm_password"
                              outlined
                              dense
                              single-line
                              placeholder="ความยาวอย่างน้อย 8 อักขระ"
                              type="password"
                              :rules="rule_confirm_password"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="12" align="right">
                            <v-btn color="primary" large type="submit">
                              <span class="text_title_4">ตกลง</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import * as rules from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: "token_inet_dev"
        }
      },

      user_id: "",
      time_expire: "",
      password: "",
      confirm_password: "",
      fullname: " - ",
      email: " - ",
      now: new Date(),
      // rules
      rule_password: rules.password,
      rule_confirm_password: [
        v => !!v || "กรุณายืนยันรหัสผ่าน",
        v => v == this.password || "รหัสผ่านไม่ถูกต้อง"
      ],
      // param
      param: {
        param_user_id: "",
        param_expire: "",
        param_name: "",
        param_email: ""
      }
    };
  },
  created() {
    this.getParam();
  },
  watch: {},
  methods: {
    getParam() {
      this.param.param_user_id = this.$route.query.userId
        ? this.$route.query.userId
        : null;
      this.param.param_expire = this.$route.query.expired
        ? new Date(this.$route.query.expired)
        : null;
      this.param.param_name = this.$route.query.name
        ? this.$route.query.name
        : null;
      this.param.param_email = this.$route.query.email
        ? this.$route.query.email
        : null;
      this.setDataAndCheckExpire();
    },
    setDataAndCheckExpire() {
      let now = new Date();
      if (now > this.param.param_expire) {
        console.log("timeout");
        this.$swal.fire({
          icon: "warning",
          title: "ไม่สามารถใช้ Link นี้ได้ !",
          text: "Link นี้ ได้หมดอายุไปแล้ว",
          timerProgressBar: true,
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          stopKeydownPropagation: false
        });
        this.$router.push("/login");
      } else {
        if (
          this.param.param_user_id &&
          this.param.param_expire &&
          this.param.param_name &&
          this.param.param_email
        ) {
          this.user_id = this.param.param_user_id;
          this.time_expire = this.param.param_expire;
          this.fullname = this.param.param_name;
          this.email = this.param.param_email;
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "ไม่สามารถใช้ Link นี้ได้ !",
            text: "เกิดข้อผิดพลาดของข้อมูล",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 2500,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            stopKeydownPropagation: false
          });
          this.$router.push("/login");
        }
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        console.log("RESET !!");
        let data = {
          userId: decodeURIComponent(this.user_id),
          password: this.password
        };
        let now = new Date();
        if (now > this.time_expire) {
          console.log("timeout");
          this.$swal.fire({
            icon: "warning",
            title: "ไม่สามารถใช้ Link นี้ได้ !",
            text: "Link นี้ ได้หมดอายุไปแล้ว",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 2500,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            stopKeydownPropagation: false
          });
          this.$router.push("/login");
        } else {
          if (this.password === this.confirm_password) {
            this.axios
              .put(
                process.env.VUE_APP_API + "api/v1/resetpassword",
                data,
                this.header_token
              )
              .then(response => {
                console.log(response.data);
                if (response.data == "update success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "รีเซ็ตรหัสผ่านสำเร็จ !",
                    text: "โปรดทำการเข้าสู่ระบบใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    allowEnterKey: true,
                    stopKeydownPropagation: true
                  });
                  this.$router.push("/login");
                } else {
                  this.$swal.fire({
                    icon: "warning",
                    title: "ไม่สามารถใช้ Link นี้ได้ !",
                    text: "เกิดข้อผิดพลาดของข้อมูล",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 2500,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    stopKeydownPropagation: false
                  });
                  this.$router.push("/login");
                }
              })
              .catch(err => {
                console.log("reset password fail");
              });
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "รหัสผ่านใหม่ไม่ถูกต้อง",
              text: "กรุณาตรวจสอบรหัสผ่านอีกครั้ง",
              timerProgressBar: true,
              showConfirmButton: false,
              timer: 2500,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              stopKeydownPropagation: false
            });
            this.password = "";
            this.confirm_password = "";
          }
        }
      }
    }
  }
};
</script>
<style>
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
</style>
